import script from "./Provision.vue?vue&type=script&setup=true&lang=ts"
export * from "./Provision.vue?vue&type=script&setup=true&lang=ts"

import "./Provision.vue?vue&type=style&index=0&id=faacdd60&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faacdd60"]])

export default __exports__